import React, { useState, useEffect } from 'react';
import { Typography, Button, TextField, List, ListItem, ListItemText, Box } from '@mui/material';
import Layout from '../layouts/layout';

export default function TipoImpressao() {
  const [tipos, setTipos] = useState([]);
  const [novoNome, setNovoNome] = useState('');
  const [novaDescricao, setNovaDescricao] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('access');

  // Fetch existing tipos de impressão
  useEffect(() => {
    setLoading(true);
    fetch('https://plasticemployers.duckdns.org/api/op/tipo-impressao/', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Erro ao buscar tipos de impressão');
        }
        return res.json();
      })
      .then((data) => {
        setTipos(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  // Handle form submission to create novo tipo de impressão
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const payload = {
      nome: novoNome,
      descricao: novaDescricao,
    };

    fetch('https://plasticemployers.duckdns.org/api/op/tipo-impressao/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Erro ao criar tipo de impressão');
        }
        return res.json();
      })
      .then((data) => {
        setTipos((prev) => [...prev, data]);
        setNovoNome('');
        setNovaDescricao('');
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };

  return (
    <Layout>
      <Typography variant="h4" gutterBottom>
        Tipo de Impressão
      </Typography>

      {/* Formulário para adicionar novo TipoImpressão */}
      <Box component="form" onSubmit={handleSubmit} sx={{ mb: 4 }}>
        <TextField
          label="Nome"
          value={novoNome}
          onChange={(e) => setNovoNome(e.target.value)}
          required
          fullWidth
          sx={{ mb: 2 }}
        />
        <TextField
          label="Descrição"
          value={novaDescricao}
          onChange={(e) => setNovaDescricao(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
        />
        <Button type="submit" variant="contained" disabled={loading}>
          Adicionar Tipo de Impressão
        </Button>
      </Box>

      {/* Exibir lista de Tipos de Impressão */}
      {loading && <Typography>Carregando...</Typography>}
      {error && <Typography color="error">{error}</Typography>}
      {!loading && !error && (
        <List>
          {tipos.map((tipo) => (
            <ListItem key={tipo.id}>
              <ListItemText primary={tipo.nome} secondary={tipo.descricao} />
            </ListItem>
          ))}
        </List>
      )}
    </Layout>
  );
}